<section [ngSwitch]="type" [ngClass]="[style === 'show' ? 'show-ntf': 'hide-ntf', type]" >
	<ng-container *ngIf="style === 'show'">
		<div class="wrapper">
			<div class="msg-block">
				<div class="msg-item">
					<div class="icon-block">
						<app-icon *ngSwitchCase="'success'">check_circle</app-icon>
						<app-icon *ngSwitchCase="'error'">report_problem</app-icon>
					</div>
					<div class="msg-text"><p>{{ message }}</p></div>
				</div>
				<div *ngIf="exceptionMessage" class="msg-item error-msg-block" [class.message-collapse]="checkMsgLength()">
					<div class="icon-block">
						<app-icon class="copy" title="{{ getTitle() }}" (click)="copyMsg()">content_copy</app-icon>
					</div>
					<div class="msg-text"><p>{{ exceptionMessage }}</p></div>
				</div>
			</div>
		</div>
		<app-icon (click)="close$.next()">close</app-icon>
	</ng-container>
</section>
